export function getValidHttpUrl(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;

  const trimmedValue = value.trim();
  if (!trimmedValue) return undefined;

  try {
    const url = new URL(trimmedValue);
    if ((url.protocol !== 'http:' && url.protocol !== 'https:') || !url.hostname) return undefined;
    return trimmedValue;
  } catch {
    return undefined;
  }
}

export function getPricingUrl(apiPricingUrl: unknown): string | undefined {
  const candidates = [
    apiPricingUrl,
    process.env.NEXT_PUBLIC_CHALLENGE_LINK,
    process.env.NEXT_PUBLIC_UPGRADE_LINK,
    process.env.NEXT_PUBLIC_SIGN_UP_LINK,
  ];

  for (const candidate of candidates) {
    const validUrl = getValidHttpUrl(candidate);
    if (validUrl) return validUrl;
  }

  return undefined;
}

export function getSignUpUrl(): string | undefined {
  return getValidHttpUrl(process.env.NEXT_PUBLIC_SIGN_UP_LINK);
}
